import { computed, type ComputedRef } from 'vue'
import { useAccountStatusQuery } from '../api/queries/useAccountStatusQuery'
import { resolveKycActionState, type KycActionState } from '../utils/financialActionsUtils'

export interface KycActionStateGate {
  // Three-way KYC gate for money-moving surfaces (wallet deposit / withdraw),
  // derived from the primed account-status cache's `accountState` — the same
  // server-owned discriminator the dashboard + top-nav read, so the wallet
  // never contradicts the nav chip. 'verified' unlocks transacting (with a
  // bank); 'in-review' shows a verification-in-progress notice (or unlocks with
  // a verified bank — decided by the consuming surface); 'action-required'
  // prompts the investor to complete (or redo) their KYC. Restriction is a
  // separate gate (useAccountAccessRestriction).
  kycActionState: ComputedRef<KycActionState>
}

export function useKycActionState(): KycActionStateGate {
  const accountStatusQuery = useAccountStatusQuery()

  const kycActionState = computed(() =>
    resolveKycActionState(accountStatusQuery.data.value?.accountState),
  )

  return { kycActionState }
}
